import { useTheme, type ThemePreference } from "../lib/theme";

const OPTIONS: ThemePreference[] = ["system", "light", "dark"];

export const ThemeToggle = () => {
  const { preference, setPreference } = useTheme();
  return (
    <div
      role="group"
      aria-label="Theme"
      className="inline-flex border border-[var(--color-kj-border)]"
    >
      {OPTIONS.map((opt, i) => {
        const active = preference === opt;
        return (
          <button
            key={opt}
            type="button"
            onClick={() => setPreference(opt)}
            className={[
              "px-2.5 py-1 text-[10px] font-light uppercase tracking-[0.06em] transition-colors cursor-pointer",
              i > 0 ? "border-l border-[var(--color-kj-border)]" : "",
              active
                ? "bg-[var(--color-kj-placeholder)] text-[var(--color-kj-text)]"
                : "text-[var(--color-kj-text-light)] hover:text-[var(--color-kj-text)]",
            ].join(" ")}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
};
